module.exports = __webpack_public_path__ + "img/logo-space.08734fba.png";